const source = (title, url, publisher) => ({ title, url, publisher });

const NHS = "NHS";
const GOV_UK = "GOV.UK";

const ARTICLE_SOURCES = {
	"cardiac-rehab-at-home-how-live-in-care-supports-recovery-after-a-heart-event": [
		source("Recovering from coronary heart disease", "https://www.nhs.uk/conditions/coronary-heart-disease/recovery/", NHS),
	],
	"coping-with-hay-fever-and-allergies-in-older-adults": [
		source("Allergies", "https://www.nhs.uk/conditions/allergies/", NHS),
		source("Hay fever", "https://www.nhs.uk/conditions/hay-fever/", NHS),
	],
	"dehydration-in-older-adults-a-commonly-missed-risk-at-home": [
		source("Dehydration", "https://www.nhs.uk/conditions/dehydration/", NHS),
	],
	"equity-release-to-pay-for-care-how-it-works-and-the-risks": [
		source("Using equity release to fund care", "https://www.moneyhelper.org.uk/en/family-and-care/long-term-care/using-an-equity-release-scheme-to-fund-your-care", "MoneyHelper"),
	],
	"heatwave-safety-for-older-adults": [
		source("Heatwave: how to cope in hot weather", "https://www.nhs.uk/live-well/seasonal-health/heatwave-how-to-cope-in-hot-weather/", NHS),
	],
	"how-do-edyns-carers-handle-food-safety": [
		source("Safer food, better business for care homes", "https://www.food.gov.uk/sites/default/files/media/document/sfbb-care-homes-pack_1.pdf", "Food Standards Agency"),
	],
	"how-do-our-carers-handle-medication-safely": [
		source("Managing medicines for adults receiving social care", "https://www.nice.org.uk/guidance/ng67/chapter/Recommendations", "NICE"),
		source("Medicines: tips for carers", "https://www.nhs.uk/social-care-and-support/practical-tips-if-you-care-for-someone/medicines-tips-for-carers/", NHS),
	],
	"insurance-considerations-for-live-in-care-home-and-car": [
		source("Vehicle insurance", "https://www.gov.uk/vehicle-insurance", GOV_UK),
		source("Home insurance: how to get the best deal", "https://www.moneyhelper.org.uk/en/everyday-money/insurance/home-insurance-how-to-get-the-best-deal", "MoneyHelper"),
	],
	"medication-reminder-apps-and-dispensers-do-they-still-matter-with-live-in-care": [
		source("Managing medicines for adults receiving social care", "https://www.nice.org.uk/guidance/ng67/chapter/Recommendations", "NICE"),
	],
	"mental-capacity-how-our-carers-respect-your-loved-ones-right-to-choose": [
		source("Mental Capacity Act code of practice", "https://www.gov.uk/government/publications/mental-capacity-act-code-of-practice", GOV_UK),
	],
	"mobility-aids-and-equipment-what-to-arrange-before-care-begins": [
		source("Care services, equipment and care homes", "https://www.nhs.uk/social-care-and-support/care-services-equipment-and-care-homes/", NHS),
	],
	"moving-and-handling-how-our-carers-keep-your-loved-one-safe-and-mobile": [
		source("Moving and handling in health and social care", "https://www.hse.gov.uk/healthservices/moving-handling/", "Health and Safety Executive"),
	],
	"nhs-prescription-costs-and-free-prescriptions-for-older-people": [
		source("Check if you can get free prescriptions", "https://www.nhs.uk/nhs-services/prescriptions/check-if-you-can-get-free-prescriptions/", NHS),
	],
	"rehabilitation-care-at-home-support-for-recovery-after-hospital": [
		source("Care after a hospital stay", "https://www.nhs.uk/social-care-and-support/care-after-a-hospital-stay/", NHS),
	],
	"self-funding-care-your-options-explained": [
		source("Paying for your own care (self-funding)", "https://www.nhs.uk/social-care-and-support/money-work-and-benefits/paying-for-your-own-care-self-funding/", NHS),
	],
	"setting-up-a-home-pharmacy-medication-storage-and-organisation": [
		source("Medicines: tips for carers", "https://www.nhs.uk/social-care-and-support/practical-tips-if-you-care-for-someone/medicines-tips-for-carers/", NHS),
	],
	"sleep-problems-in-older-adults-causes-and-home-based-solutions": [
		source("Insomnia", "https://www.nhs.uk/conditions/insomnia/", NHS),
	],
	"utis-and-sudden-confusion-in-older-adults-why-it-is-often-mistaken-for-dementia": [
		source("Urinary tract infections (UTIs)", "https://www.nhs.uk/conditions/urinary-tract-infections-utis/", NHS),
	],
	"what-happens-if-there-is-an-accident": [
		source("Falls", "https://www.nhs.uk/conditions/falls/", NHS),
	],
	"what-happens-when-your-loved-one-goes-into-hospital": [
		source("Going into hospital", "https://www.nhs.uk/nhs-services/hospitals/going-into-hospital/", NHS),
	],
	"what-happens-when-your-loved-one-is-discharged-from-hospital-or-a-care-home": [
		source("Being discharged from hospital", "https://www.nhs.uk/nhs-services/hospitals/going-into-hospital/being-discharged-from-hospital/", NHS),
		source("Hospital discharge and community support guidance", "https://www.gov.uk/government/publications/hospital-discharge-and-community-support-guidance", GOV_UK),
	],
	"what-is-an-fp10-the-nhs-prescription-form-explained": [
		source("FP10 prescription form specification", "https://www.nhsbsa.nhs.uk/sites/default/files/2020-10/Overprint%20specification%20for%20FP10SS%20forms%20v2.1%20October%202020_0.pdf", "NHS Business Services Authority"),
	],
	"winter-safety-for-older-adults": [
		source("Seasonal health", "https://www.nhs.uk/live-well/seasonal-health/", NHS),
	],
};

export const getArticleSources = (slug) => ARTICLE_SOURCES[slug] || [];
